<nav
  class="fixed left-0 right-0 top-0 z-50 bg-gradient-to-r from-cnfpc-primary-lightest to-cnfpc-primary-lightest shadow-3xl"
>
  <div class="container mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex h-24 items-center justify-between">
      <!-- Logo and Title (Left) -->
      <a routerLink="/home">
        <div class="flex items-center gap-3">
          <img
            src="assets/img/logo-cnfpc-3.png"
            alt="logo cnfpc"
            class="logoHeight"
          />
          <div class="border-l border-cnfpc-primary/30 pl-3">
            <span class="text-lg font-medium text-cnfpc-primary/80">
              <span
                class="bg-cnfpc-secondary-lightest rounded-md pl-1 pr-1 text-2xl font-bold text-red-500"
              >
                @if (environmentLabel()) {
                  {{ environmentLabel() }}
                } @else {
                  &nbsp;
                }
              </span>
            </span>
          </div>
        </div>
      </a>

      <!-- Mobile Menu Button -->
      <button
        (click)="toggleMobileMenu()"
        class="text-cnfpc-primary-dark lg:hidden"
      >
        <i class="material-icons text-2xl">{{
          isMobileMenuOpen() ? "close" : "menu"
        }}</i>
      </button>

      <!-- Desktop Navigation (Centered) -->
      <div class="hidden flex-1 justify-center lg:flex">
        <div class="flex items-center space-x-10">
          <div
            *ngIf="account()"
            class="group relative"
            (mouseenter)="activeDropdown = 'formations'"
            (mouseleave)="activeDropdown = null"
          >
            <a
              routerLink="/formations"
              [routerLinkActive]="activeLink"
              class="group flex items-center gap-1 text-lg font-medium text-cnfpc-primary-dark transition-all duration-300 hover:text-cnfpc-primary-darker"
            >
              Formations
              <i
                class="material-icons transform transition-transform duration-300 group-hover:rotate-180"
                >expand_more</i
              >
            </a>

            @if (activeDropdown === "formations") {
              <div class="absolute -bottom-2 left-0 h-2 w-full"></div>
              <div
                class="absolute left-0 mt-2 w-56 rounded-md bg-cnfpc-secondary-whiter py-2 shadow-3xl"
              >
                <a
                  routerLink="/formations"
                  class="flex items-center gap-3 px-4 py-3 text-sm text-cnfpc-primary-black transition-all duration-300 hover:bg-cnfpc-primary-lighter hover:text-cnfpc-primary"
                >
                  <i class="material-icons">library_books</i>
                  Liste des formations
                </a>
                <a
                  routerLink="/formations/new"
                  class="flex items-center gap-3 px-4 py-3 text-sm text-cnfpc-primary-black transition-all duration-300 hover:bg-cnfpc-primary-lighter hover:text-cnfpc-primary"
                >
                  <i class="material-icons">add_circle</i>
                  Ajouter formation
                </a>
              </div>
            }
          </div>

          <div
            *ngIf="account()"
            class="group relative"
            (mouseenter)="activeDropdown = 'sessions'"
            (mouseleave)="activeDropdown = null"
          >
            <a
              routerLink="/sessions"
              [routerLinkActive]="activeLink"
              class="group flex items-center gap-1 text-lg font-medium text-cnfpc-primary-dark transition-all duration-300 hover:text-cnfpc-primary-darkest"
            >
              Sessions
              <i
                class="material-icons transform transition-transform duration-300 group-hover:rotate-180"
                >expand_more</i
              >
            </a>

            @if (activeDropdown === "sessions") {
              <div class="absolute -bottom-2 left-0 h-2 w-full"></div>
              <div
                class="absolute left-0 mt-2 w-56 rounded-md bg-cnfpc-secondary-whiter py-2 shadow-3xl"
              >
                <a
                  routerLink="/sessions"
                  class="flex items-center gap-3 px-4 py-3 text-sm text-cnfpc-primary-black transition-all duration-300 hover:bg-cnfpc-primary-lighter hover:text-cnfpc-primary"
                >
                  <i class="material-icons">library_books</i>
                  Liste des sessions
                </a>
                <a
                  routerLink="/sessions/new"
                  class="flex items-center gap-3 px-4 py-3 text-sm text-cnfpc-primary-black transition-all duration-300 hover:bg-cnfpc-primary-lighter hover:text-cnfpc-primary"
                >
                  <i class="material-icons">add_circle</i>
                  Ajouter session
                </a>
              </div>
            }
          </div>

          <!-- <div *ngIf="account()" class="group relative">
            <a
              routerLink="/learners"
              [routerLinkActive]="activeLink"
              class="[&:not(.text-cnfpc-secondary-blue)] group flex items-center gap-1 text-lg font-medium text-cnfpc-primary-lightest transition-all duration-300 hover:text-cnfpc-secondary-blue"
            >
              Apprenants
            </a>
          </div> -->

          <div
            *ngIf="account() && (isAdmin() || isAGest())"
            class="group relative"
          >
            <a
              routerLink="/ressources/formateurs"
              [routerLinkActive]="activeLink"
              class="[&:not(.text-cnfpc-secondary-blue)] group flex items-center gap-1 text-lg font-medium text-cnfpc-primary-dark transition-all duration-300 hover:text-cnfpc-primary-darker"
            >
              Ressources
            </a>
          </div>

          <div
            *ngIf="account() && (isAdmin() || isAGest())"
            class="group relative"
          >
            <a
              routerLink="/inscriptions"
              [routerLinkActive]="activeLink"
              class="[&:not(.text-cnfpc-secondary-blue)] group flex items-center gap-1 text-lg font-medium text-cnfpc-primary-dark transition-all duration-300 hover:text-cnfpc-primary-darker"
            >
              Inscriptions
            </a>
          </div>

          <div *ngIf="account() && isAdmin()" class="group relative">
            <a
              routerLink="/admin"
              [routerLinkActive]="activeLink"
              class="[&:not(.text-cnfpc-secondary-blue)] group flex items-center gap-1 text-lg font-medium text-cnfpc-primary-dark transition-all duration-300 hover:text-cnfpc-primary-darker"
            >
              Paramètres
            </a>
          </div>
        </div>
      </div>

      <!-- Desktop User Profile (Right) - UPDATED WITH PROFILE PICTURE -->
      <div class="hidden lg:block">
        <button
          (click)="toggleProfileDropdown()"
          class="flex items-center gap-3 rounded-full border-cnfpc-primary-dark bg-cnfpc-primary-darkest px-4 py-2 text-cnfpc-primary-lightest transition-all duration-300 hover:border-2 hover:bg-cnfpc-primary-dark hover:text-white focus:bg-cnfpc-primary-black"
        >
          <div
            class="flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-transparent"
          >
            <img
              *ngIf="profilePhoto(); else defaultIcon"
              [src]="profilePhoto()"
              alt="Profile picture"
              class="h-full w-full rounded-full object-cover"
            />
            <ng-template #defaultIcon>
              <i class="material-icons text-cnfpc-secondary-white">person</i>
            </ng-template>
          </div>
          <span class="text-sm font-medium">{{ username() }}</span>
          <i
            class="material-icons transition-transform duration-300"
            [class.rotate-180]="isProfileOpen()"
            >expand_more</i
          >
        </button>

        <div
          *ngIf="isProfileOpen()"
          class="absolute right-0 mt-2 w-48 rounded-md bg-cnfpc-secondary-whiter py-2 shadow-3xl"
        >
          <!-- <a
            routerLink="/profile"
            class="flex items-center gap-2 px-4 py-3 text-sm text-cnfpc-primary-darker transition-all duration-300 hover:bg-cnfpc-primary-lightest hover:text-cnfpc-primary-darkest"
          >
            <i class="material-icons text-cnfpc-primary">person</i>
            Profile
          </a> -->
          <a
            (click)="logout()"
            class="flex cursor-pointer items-center gap-2 px-4 py-3 text-sm text-cnfpc-primary-black transition-all duration-300 hover:bg-cnfpc-primary-lighter hover:text-cnfpc-primary"
          >
            <i class="material-icons">logout</i>
            Déconnexion
          </a>
        </div>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div
      *ngIf="isMobileMenuOpen()"
      class="absolute left-0 right-0 top-24 bg-cnfpc-primary-darker px-4 py-4 shadow-3xl lg:hidden"
    >
      <div class="flex flex-col space-y-4">
        <!-- Mobile Formations Dropdown -->
        <div *ngIf="account()">
          <button
            (click)="toggleMobileSubmenu('formations')"
            class="flex w-full items-center justify-between py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
          >
            <span>Formations</span>
            <i class="material-icons">{{
              mobileSubmenuOpen() === "formations"
                ? "expand_less"
                : "expand_more"
            }}</i>
          </button>
          @if (mobileSubmenuOpen() === "formations") {
            <div class="mt-2 space-y-2 pl-4">
              <a
                routerLink="/formations"
                class="flex items-center gap-2 py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
              >
                <i class="material-icons text-sm">library_books</i>
                <span>Liste des formations</span>
              </a>
              <a
                routerLink="/formations/new"
                class="flex items-center gap-2 py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
              >
                <i class="material-icons text-sm">add_circle</i>
                <span>Ajouter formation</span>
              </a>
            </div>
          }
        </div>

        <div *ngIf="account()">
          <button
            (click)="toggleMobileSubmenu('sessions')"
            class="flex w-full items-center justify-between py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
          >
            <span>Sessions</span>
            <i class="material-icons">{{
              mobileSubmenuOpen() === "sessions" ? "expand_less" : "expand_more"
            }}</i>
          </button>
          @if (mobileSubmenuOpen() === "sessions") {
            <div class="mt-2 space-y-2 pl-4">
              <a
                routerLink="/sessions"
                class="flex items-center gap-2 py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
              >
                <i class="material-icons text-sm">library_books</i>
                <span>Liste des sessions</span>
              </a>
              <a
                routerLink="/sessions/new"
                class="flex items-center gap-2 py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
              >
                <i class="material-icons text-sm">add_circle</i>
                <span>Ajouter session</span>
              </a>
            </div>
          }

          <button
            (click)="toggleMobileSubmenu('ressources')"
            class="flex w-full items-center justify-between py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
          >
            <a
              routerLink="/ressources/formateurs"
              class="flex items-center gap-2 py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
            >
              <span>Ressources</span>
            </a>
          </button>

          <button
            (click)="toggleMobileSubmenu('inscriptions')"
            class="flex w-full items-center justify-between py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
          >
            <a
              routerLink="/inscriptions"
              class="flex items-center gap-2 py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
            >
              <span>Inscriptions</span>
            </a>
          </button>
        </div>

        <!-- <a
          *ngIf="account()"
          routerLink="/learners"
          class="py-2 text-cnfpc-primary-lightest hover:text-cnfpc-secondary-blue"
          >Apprenants</a
        > -->
        <a
          *ngIf="account() && isAdmin()"
          routerLink="/admin"
          class="py-2 text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
          >Paramètres</a
        >

        <!-- Mobile User Profile - UPDATED WITH PROFILE PICTURE -->
        <div class="mt-4 border-t border-cnfpc-primary-lightest/20 pt-4">
          <div class="mb-4 flex items-center gap-3">
            <div
              class="flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-cnfpc-primary-darkest"
            >
              <img
                *ngIf="profilePhoto(); else mobileDefaultIcon"
                [src]="profilePhoto()"
                alt="Profile picture"
                class="h-full w-full rounded-full object-cover"
              />
              <ng-template #mobileDefaultIcon>
                <i class="material-icons text-cnfpc-secondary-white">person</i>
              </ng-template>
            </div>
            <span class="text-cnfpc-primary-lightest">{{ username() }}</span>
          </div>
          <!-- <a
            routerLink="/profile"
            class="flex items-center gap-2 py-2 text-cnfpc-primary-lightest hover:text-cnfpc-secondary-blue"
          >
            <i class="material-icons text-sm">person</i>
            <span>Profile</span>
          </a> -->
          <a
            (click)="logout()"
            class="flex cursor-pointer items-center gap-2 py-2 text-cnfpc-error hover:text-red-400"
          >
            <i class="material-icons text-sm text-cnfpc-secondary-white"
              >logout</i
            >
            <span
              class="text-cnfpc-secondary-white hover:text-cnfpc-secondary-black"
              >Logout</span
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</nav>
